'use strict';

/* videopage.js -- entry for the video watch page; loaded with `defer` by VideoPage.cshtml */

var videoSeek = require('./components/videoSeek');
var videoTracking = require('./components/videoTracking');
var h5yrEngagement = require('./components/h5yrEngagement');

videoSeek.init();
videoTracking.init();
h5yrEngagement.init(videoTracking.h5yrEngaged);
